module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEASURBVHgBpVHtEcFAEL3cKCAdUAIVKEEumfymAzpABagABeRDBagAHVCBayCJ98gZ4vwIO3Oztx/v7c5bIX4051vB9/0R3BhvF8exqtalDeR5XqsoimGe5x2ELaVUt9rTKNkHcCxqNC+klFv4SZqmZ9Rs3EKC3YWfOY6zuyekPHA9gNZlD6efbKsSqKMoWgO0QROnTk0DCZG/YnLBh0Gz56oVO3NFE4DwTRiASTK3ivPNwjBscyOofKkFzLKs99RC1DMPE1dWIBjbvOMH4nFbN0mSvQFqfoIg4O2omAZ4i8b+C8iFsmOz5n2AYUOyyX95M8ZLTi/7NPJHPAXFtfjHbnETd++5qrqJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f1.png
// module id = ddHw
// module chunks = 1